import {AppButtonIcon} from "@components"
import {REAL_TIME_ROUTES} from "@constants"
import {Box, Divider} from "@mui/material"
import {analyzerFilters, openEvolutionModal} from "Pages/AnalyzersV2/@signals"
import React from "react"

export default function PopoverLinks({ id_search, screenshot, evolutionFilter, priceData, hideEvolution = false }) {

	return <>
		<Divider sx={{ my: .5 }}/>
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-around" }}>
			{!hideEvolution && <Box
				data-tour-id="tour-popover-evolution"
				onClick={() => {
					openEvolutionModal.value = {
						price_data: evolutionFilter,
						filters: analyzerFilters.value,
						tableRows: [ priceData ],
					}
				}}
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: "5px",
					border: "1px solid",
					width: 22,
					height: 22,
					borderColor: "success.main",
					cursor: "pointer",
					"& :hover": {
						borderColor: "success.dark",
					},
				}}>
				<AppButtonIcon
					color="success"
					icon="chart-line"
					tooltip="Evolution Chart"
					sx={{ fontSize: "0.80rem", p: 0 }}
				/>
			</Box>}
			{ !!id_search && <Box data-tour-id="tour-popover-realtime"><AppButtonIcon
				color="warning"
				icon="magnifying-glass"
				tooltip="Real-Time Searches"
				onClick={e => {
					window.open(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${id_search}`, "_blank")
					if (e.ctrlKey) e.preventDefault()
				}}
				onAuxClick={e => {
					if (e.button === 1) {
						window.open(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${id_search}`, "_blank")
						e.preventDefault()
					}
				}}
			/></Box>}
			{ !!screenshot && <Box data-tour-id="tour-popover-screenshot"><AppButtonIcon
				color="info"
				icon="image"
				tooltip="Screenshot"
				onClick={e => {
					window.open(screenshot)
					if (e.ctrlKey) e.preventDefault()
				}}
				onAuxClick={e => {
					if (e.button === 1) {
						window.open(screenshot)
						e.preventDefault()
					}
				}}
			/></Box>}
		</Box>
	</>

}